import { PasscodesDeviceDto } from 'services/passcodes/passcodes.service';
import { filterLocks, normalizeText } from './lock-filter';
import { orderLocksByRecents } from './lock-recents';

export interface SiteGroup {
    siteName: string;
    count: number;
    locks: PasscodesDeviceDto[];
}

const byText = (a: string, b: string): number => normalizeText(a).localeCompare(normalizeText(b));

export function groupBySite(locks: PasscodesDeviceDto[]): SiteGroup[] {
    const bySite = new Map<string, PasscodesDeviceDto[]>();
    for (const lock of locks) {
        const list = bySite.get(lock.site_name);
        if (list) {
            list.push(lock);
        } else {
            bySite.set(lock.site_name, [lock]);
        }
    }
    return Array.from(bySite.entries())
        .map(([siteName, siteLocks]) => ({
            siteName,
            count: siteLocks.length,
            locks: [...siteLocks].sort((a, b) => byText(a.lock_name, b.lock_name)),
        }))
        .sort((a, b) => byText(a.siteName, b.siteName));
}

export type BrowseModel =
    | { mode: 'browse'; recents: PasscodesDeviceDto[]; sites: SiteGroup[] }
    | { mode: 'results'; results: PasscodesDeviceDto[] };

export function buildBrowseModel(locks: PasscodesDeviceDto[], recentIds: string[], query: string): BrowseModel {
    if (query.trim()) {
        return { mode: 'results', results: filterLocks(locks, query) };
    }
    const { recents } = orderLocksByRecents(locks, recentIds);
    return { mode: 'browse', recents, sites: groupBySite(locks) };
}

export function buildSiteModel(locks: PasscodesDeviceDto[], siteName: string, query: string): PasscodesDeviceDto[] {
    const inSite = locks.filter((l) => l.site_name === siteName);
    const q = normalizeText(query.trim());
    const filtered = q ? inSite.filter((l) => normalizeText(l.lock_name).includes(q)) : inSite;
    return [...filtered].sort((a, b) => byText(a.lock_name, b.lock_name));
}
